<div id="buttoncomponent" [style.background]="background" [style.color]="color" (click)="clicked()">
    <div class="iconbutton" [style.background]="getIcon" *ngIf="iconlocation"></div>
    <div class="textbutton">{{text}}</div>
</div>
